import React, { useState } from 'react';
import { Accordion, Icon, Label, Loader } from 'semantic-ui-react';
import RfiResponseItem from './RfiResponseItem';
import { format } from 'date-fns';
import '../styles.scss';

interface RfiResponseListProps {
  rfiResponses: any;
  investorName?: string;
  type?: string;
  tableView?: boolean;
  loading?: boolean;
}
const RfiResponseList: React.FC<RfiResponseListProps> = ({ rfiResponses, investorName, type, tableView = false, loading = false }) => {
  const [activeAccordionIndex, setActiveAccordionIndex] = useState<number>(-1);

  const handleAccordionClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const newIndex = activeAccordionIndex === index ? -1 : index;
    setActiveAccordionIndex(newIndex);
  };

  if (loading) {
    return (
      <div className={tableView ? 'table-view rfi-response-list' : 'rfi-response-list'} style={{ padding: '24px', textAlign: 'center' }}>
        <Loader active inline="centered" />
      </div>
    );
  }

  if (tableView && rfiResponses.length > 0) {
    return (
      <div className="table-view rfi-response-list">
        <Accordion fluid styled>
          {rfiResponses.map(
            (
              response: { name: string; description: string; content: string | null; snippet: string; updatedAt?: string; },
              index: number
            ) => (
              <React.Fragment key={index}>
                <Accordion.Title
                  active={activeAccordionIndex === index}
                  index={index}
                  onClick={handleAccordionClick}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <div>
                      <Icon name="dropdown" />
                      {response.name}
                    </div>
                    <div>
                      {response.updatedAt ? (
                        <span style={{ marginRight: '8px', fontSize: '0.9em', color: '#666', fontWeight: '400', fontStyle: 'italic' }}>
                          Last updated {format(new Date(response.updatedAt), 'MMM d, yyyy')}
                        </span>
                      ) : null}
                      {response.content ? (
                        <Label color="green">
                          Answered
                        </Label>
                      ) : (
                        <Label color="grey" style={{ marginLeft: '8px' }}>
                          Awaiting response
                        </Label>
                      )}
                    </div>
                  </div>
                </Accordion.Title>
                <Accordion.Content active={activeAccordionIndex === index}>
                  <div className="rfi-accordion-content">
                    <p className="rfi-response-description">{response.description}</p>
                    <div className="rfi-response-content">
                      <strong>Response from {investorName}:</strong>
                      <div
                        className="response-text"
                        dangerouslySetInnerHTML={{ __html: response?.content || 'No response provided' }}
                      />
                      {response.updatedAt && (
                        <span className="rfi-response-updated-at">
                          Last updated {format(new Date(response.updatedAt), 'MMM d, yyyy h:mm a')}
                        </span>
                      )}
                    </div>
                  </div>
                </Accordion.Content>
              </React.Fragment>
            )
          )}
        </Accordion>
      </div>
    );
  }

  return (
    <div className={tableView ? 'table-view rfi-response-list' : 'rfi-response-list'}>
      {rfiResponses.length > 0 && (
        <>
          {/* {(type !== 'portfolio' && !tableView) && (
            <p className='table-info section-header'>Supporting information</p>
          )} */}
          <div className='calculations-container'>
            <div>
              {rfiResponses.map(
                (
                  response: { name: string; description: string; content: string | null; snippet: string; },
                  index: number
                ) => (
                  <RfiResponseItem key={index} rfiResponse={response} investorName={investorName} />
                )
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RfiResponseList;